/*globals $:false,mermaid:false */
import tmpl_diagram from '../templates/definitions.diagram-viewer.dot';
import utils from '@cob/ui-genesis/cob.utils.js';

// args:
// * `core`: cob.app
// * `$container`: The html container
//
// confs:
// * showReferences: If the diagram should include referenced definitions. Defaults to true
// * showLabels: : If the diagram should include labels. Defaults to true
//
// callbacks:
// * updateDiagram(confs): update the diagram with the new confs
const DefinitionsDiagramV = function (core, $container, opts, callbacks) {

    let _$showReferences
    let _$showLabels

    const _getOpts = function () {
        return {
            showReferences: _$showReferences.is(":checked"),
            showLabels: _$showLabels.is(":checked")
        }
    }

    const _init = function () {
        $container.append($(tmpl_diagram(opts)))

        _$showReferences = $(".js-diagram-references", $container)
        _$showLabels = $(".js-diagram-labels", $container)

        $(".js-close-diagram", $container).on('click', () => {
            $(".js-diagram-wrapper", $container).remove()
        })

        _$showReferences.change(() => {
            callbacks.updateDiagram(_getOpts())
        })

        _$showLabels.on('change', () => {
            callbacks.updateDiagram(_getOpts())
        })
    }

    _init()

    const createLink = (src) => {
        const mermaidStringified = JSON.stringify({code: src, mermaid: {theme: "default"}});
        const mermaidEncoded = new TextEncoder().encode(mermaidStringified);
        return `https://mermaid.live/edit#base64:${btoa(String.fromCodePoint(...mermaidEncoded))}`;
    }

    const _show = function (diagramDefinition) {
        const normalLink = createLink(diagramDefinition)
        const cleanLink = createLink(diagramDefinition)

        const $diagramContainer = $(".js-diagram-container", $container)

        $diagramContainer
            .empty()
            .append(`<a href="${normalLink}" target="_blank" onclick="if(event.altKey || event.metaKey) { event.preventDefault(); window.open('${cleanLink}', '_blank'); }">Mermaid link</a>`)
            .append(`<pre class="mermaid !bg-white !border-0">` + diagramDefinition + '</pre>')

        mermaid.run()
    }

    return {
        show: _show
    }
}

export default DefinitionsDiagramV;